import {
  jb_menu_item_css_default
} from "./chunk.TGM7JKUB.js";
import {
  Linkable
} from "./chunk.SUDKOARH.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-menu-item/jb-menu-item.ts
var JbMenuItem = class extends Initiable(Linkable(r)) {
  constructor() {
    super(...arguments);
    this.hidden = false;
    this.notTabbable = false;
    this.type = "primary";
  }
  render() {
    return ke`<div class="menu-item ${this.type} ${this.hidden ? "hidden" : ""}">
      <a
        data-linkable
        .tabIndex=${this.notTabbable ? -1 : 0}
      >
        <span>${this.text}</span>
        ${this.submenu && ke`<jb-arrow-forward-icon></jb-arrow-forward-icon>`} ${this.tag && ke`<p>${this.tag}</p>`}
      </a>
    </div>`;
  }
};
JbMenuItem.styles = [reset_css_default, jb_menu_item_css_default];
JbMenuItem.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbMenuItem.prototype, "hidden", 2);
__decorateClass([
  n({ type: Object })
], JbMenuItem.prototype, "link", 2);
__decorateClass([
  n({ type: Boolean })
], JbMenuItem.prototype, "notTabbable", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "submenu", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "tag", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "text", 2);
__decorateClass([
  n()
], JbMenuItem.prototype, "type", 2);
JbMenuItem = __decorateClass([
  customElement("jb-menu-item")
], JbMenuItem);

export {
  JbMenuItem
};
